import React from 'react';

const FormGroupRadio = ({children, label}) => {
	return (
		<div className="form-group pms-radio-wrap">
			<label htmlFor="">{label}</label>
			<div className="flex gap-85px">{children}</div>
		</div>
	);
};

export default FormGroupRadio;